import { FORM_CLOSED_MESSAGE_CLASS, RicosViewer, useRicosTheme } from '@wix/form-fields';
import React from 'react';
import { DATA_HOOKS } from '../../tpa/widget/data-hooks';
import styles from './disabled-form-overlay.module.scss';
const paragraphCustomStylesWUT = {
    p: {
        fontSize: 'var(--wix-forms-formParagraphFont-size)',
        fontFamily: 'var(--wix-forms-formParagraphFont-family)',
        color: 'rgb(var(---wix-forms-formParagraphColor))'
    }
};
const RICOS_THEME = {
    customStyles: paragraphCustomStylesWUT
};
export const DisabledFormOverlay = ({ content })=>{
    const customTheme = useRicosTheme(RICOS_THEME);
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.disabledFormOverlay
    }, /*#__PURE__*/ React.createElement(RicosViewer, {
        dataHook: DATA_HOOKS.FORM_CLOSED_MESSAGE,
        content: content,
        className: FORM_CLOSED_MESSAGE_CLASS,
        customTheme: customTheme
    }));
};

//# sourceMappingURL=disabled-form-overlay.js.map